
import GeneralState from './General';
import PrivateMessageState from './PrivateMessage';
import UserState from './User';
import HourseBetState from './HourseBet';
import ProductState from './Product';
import CustomerState from './Customer';
import QrCodeState from './QrCode';
import OrderState from './Order'
import SocketOp from './SocketOp'

const stores = {
    GeneralStore: new GeneralState(),
    HourseBetStore : new HourseBetState,
    OrderStore: new OrderState(),
    privateMessage : new PrivateMessageState(),
    UserStore : new UserState,
    ProductStore : new ProductState(),
    CustomerStore : new CustomerState(),
    QrCodeStore : new QrCodeState(),
    SocketStore : new SocketOp()

  };

  export default stores;